export const getUseCasesTabsOptions = (t) => [
  { value: 'recent', label: t('sidebar.tabs.recent') },
  { value: 'popular', label: t('sidebar.tabs.popular') },
]
